// extracted by mini-css-extract-plugin
module.exports = {"feature":"cd01fbf7b5--feature--IyLar","value":"cd01fbf7b5--value--scK4_"};